module.exports = __webpack_public_path__ + "img/01.37557a65.png";